export const PrioritiesConfig = {
    name            : 'Priorities',
    icon            : 'i5-priority',
    image           : 'priorities',
    iconSvg         : 'isvg-view-priorities',
    url             : 'priorities',
    description     : 'Tasks groups and sorted by priority, from highest to lowest.',
    canBeInProject  : true,
}

export const CUSTOM_VIEW_PRIORITIES_CONFIG = {
    ...PrioritiesConfig,
    // key2: "newValue2",  // Replacing the value for key2
}